module.exports = __webpack_public_path__ + "static/media/Password_Icon.4efec32b.svg";